import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../../utils/date-time-utility";

const formatAppointmentDate = (date: Date): string => {
  return dayjs(date).format(DATE_FORMAT);
};

const formatAppointmentTime = (date: Date): string => {
  return dayjs(date).format("hh:mm A");
};

export const formatAppointmentDateTime = (
  date: Date,
  duration: number
): string => {
  const formattedDate = formatAppointmentDate(date);
  const formattedTime = formatAppointmentTime(date);
  return `${formattedDate}, ${formattedTime} (${duration} min)`;
};


export const isPastAppointment = (date: Date): boolean => {
  return dayjs(date).isBefore(dayjs(), "day");
};

